import { useEffect, useState } from 'react';
import axios from 'axios';

import { Save16w } from '../../../images/icons/icons_component';

function OperRegTrnList_popup() {
    const today = new Date();
    const currentYear = today.getFullYear();

    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    } else {
        currentMonth = String(currentMonth);
    }

    const [data, setData] = useState({});
    const sendData = JSON.parse(localStorage.getItem('operRegTrnListData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/trnlst/operrsltRegTrnDetail.do', {
                params: sendData
            });
            setData(response.data);
            console.log(response.data);
            console.log(sendData);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };

    const isAdd = sendData.flag === 'add';
    const isUpdate = sendData.flag === 'update';

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchYear: currentYear,
        search_month: currentMonth,
        searchReg: isAdd ? '' : sendData.IEM_ID,
        searchCreate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchUpdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const monthOptions = Array.from({ length: 12 }, (_, i) => {
        const value = String(i + 1).padStart(2, '0');
        return (
            <option key={value} value={value} selected={value === currentMonth}>
                {value} 월
            </option>
        );
    });

    useEffect(() => {
        popupData();
    }, []);

    useEffect(() => {
        if (!isAdd && data.BEGIN_DE && data.END_DE) {
            setSearchParams((prev) => ({
                ...prev,
                searchFromdate: data.BEGIN_DE,
                searchTodate: data.END_DE,
                searchCreate: data.CREAT_DT,
                searchUpdate: data.UPDT_DT || '',
            }));
        }
    }, [data]);

    const save = async () => {
        const confirmMessage = sendData.flag === 'add' ? "저장하시겠습니까?" : "수정하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        const totalObj = {
            ...searchParams,
            flag: sendData.flag,
            userId: localStorage.getItem("id"),
        };

        try {
            const response = await axios.get("/trmsapi/trnlst/operrsltRegTrnDetailSave.do", {
                params: totalObj,
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    }

    return (
        <div className='popup_font py-6 px-8 w-full h-screen bg_tr_bg'>
            <div className='flex justify-between mb-2'>
                <h5 className='sub_title m-0 p-0'>등록일정관리 {sendData.flag === 'add' ? '추가' : '수정'}</h5>
                <button onClick={save} className='search_btn bg_tr_primary'><Save16w />{sendData.flag === 'add' ? '저장' : '수정'}</button>
            </div>
            <div className="com-search tr_pop_th_bg border-l border-r">
                <hr className='border-t-2 tr_border_primary' />
                <table>
                    <colgroup>
                        <col width='15%' />
                        <col width='35%' />
                        <col width='15%' />
                        <col width='35%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>연번</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchReg"
                                    name="searchReg"
                                    className='input_style'
                                    value={isAdd ? '' : data.IEM_ID || ''}
                                    readOnly
                                />
                            </td>
                            <th>일정명칭</th>
                            <td>
                                <div className='flex gap-1 items-center'>
                                    {isAdd ? (
                                        <>
                                            <select
                                                id="searchYear"
                                                name="searchYear"
                                                value={searchParams.searchYear}
                                                onChange={handleInputChange}
                                            >
                                                {Array.from({ length: 12 }, (_, i) => {
                                                    const year = (currentYear + 1 - i).toString();
                                                    return (
                                                        <option key={year} value={year}>
                                                            {year}년
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            <select
                                                id="search_month"
                                                name="search_month"
                                                value={searchParams.search_month}
                                                onChange={handleInputChange}
                                            >
                                                {monthOptions}
                                            </select>
                                        </>
                                    ) : isUpdate ? (
                                        <>
                                            <select id="searchYear" name="searchYear">
                                                <option value={data.STDR_YM?.slice(0, 4)}>{data.STDR_YM?.slice(0, 4)}</option>
                                            </select>
                                            <select id="search_month" name="search_month">
                                                <option value={data.STDR_YM?.slice(4, 6)}>{data.STDR_YM?.slice(4, 6)}</option>
                                            </select>
                                        </>
                                    ) : null}
                                    실적 등록
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <th>등록기간</th>
                            <td colSpan={3}>
                                <input
                                    type="date"
                                    id="searchFromdate"
                                    name="searchFromdate"
                                    onChange={handleInputChange}
                                    value={searchParams.searchFromdate}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    id="searchTodate"
                                    name="searchTodate"
                                    onChange={handleInputChange}
                                    value={searchParams.searchTodate}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>생성일</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchCreate"
                                    name="searchCreate"
                                    className='input_style'
                                    value={searchParams.searchCreate}
                                    readOnly
                                />
                            </td>
                            <th>수정일</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchUpdate"
                                    name="searchUpdate"
                                    className='input_style'
                                    value={searchParams.searchUpdate}
                                    readOnly
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default OperRegTrnList_popup;
